import { GeoLocation } from "../types/site";

export function getGoogleMapsDirectionUrl(location: GeoLocation): string {
  return `https://www.google.com/maps/dir/?api=1&destination=${location.latitide},${location.longitude}&travelmode=driving`;
}

export function getGoogleMapsAddressUrl(location: GeoLocation): string {
  return `https://maps.google.com/?q=${location.latitide},${location.longitude}`;
}
